import React, { memo } from 'react';

export default memo(function Success() {
  return (
    <svg width="80px" height="80px" viewBox="0 0 68.966 68.966">
      <g
        id="success"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="Componentes" transform="translate(-458 -1669)" fill="#389F4D">
          <g id="Icons/corret" transform="translate(456 1667)">
            <path
              d="M36 6c16.542 0 30 13.458 30 30s-13.458 30 -30 30 -30 -13.458 -30 -30S19.458 6 36 6m0 3.528c-14.595 0 -26.472 11.877 -26.472 26.472s11.877 26.472 26.472 26.472 26.472 -11.877 26.472 -26.472S50.595 9.528 36 9.528m10.482 18.207a1.764 1.764 0 1 1 2.568 2.418L35.763 44.268a1.77 1.77 0 0 1 -2.466 0.102L25.407 37.248a1.747 1.747 0 0 1 -0.129 -2.487 1.738 1.738 0 0 1 1.221 -0.582 1.802 1.802 0 0 1 1.272 0.45L34.377 40.59Z"
              id="success"
            />
          </g>
        </g>
      </g>
    </svg>
  );
});
